export const API_BASE_URL = 'https://atrux-717ecf8763ea.herokuapp.com/api/v0.1';

export const API_BASE_URL_WITH_SLASH = `${API_BASE_URL}/`;
